import React from "react";
import "./Main.module.css";
import { Outlet } from "react-router-dom";
import Footer from "../Pages/Shared/Footer/Footer";
import Header from "../Pages/Shared/Header/Header";
// import LeftSideNav from '../Pages/Shared/LeftSideNav/LeftSideNav';
// import RightSideNav from '../Pages/Shared/RightSideNav/RightSideNav';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Main = () => {
  return (
    <div>
      <Header />
      <div>
        <div className="mb-4">
          <Row>
            <Col lg="" className="outlet rounded-2 mb-5">
              <Outlet />
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Main;
